export default {
    computed: {
        /**
         * get store field values
         * @returns Object
         */
        fieldValues: function () {
            return this.$store.state.fieldValues;
        }
    },
    methods: {
        /**
         * get form field values
         * @returns object
         */
        getFormData() {

            let data = {};

            // get values from every field from "validateFields"
            for(let i in this.validateFields) {
                data[this.validateFields[i]] = this.fieldValues[this.validateFields[i]];
            }

            return data;
        },

        getRequestData() {
            let params = new FormData();

            for(let i in this.validateFields) {
                params.append(this.validateFields[i], this.fieldValues[this.validateFields[i]]);
            }

            return params;
        }
    }
}
